varying vec2 vUv;
varying vec3 vWorldPos;    

uniform sampler2D u_tex;
uniform float noiseScale;
uniform float noiseStrength;
uniform vec2 u_texelSize;
uniform float blurStrength;
uniform float opacity;   

#pragma glslify: noise = require('../partials/noise.glsl')

void main() {
  vec2 offsets[9];
  offsets[0] = vec2(-1.0, -1.0);
  offsets[1] = vec2( 0.0, -1.0);
  offsets[2] = vec2( 1.0, -1.0);
  offsets[3] = vec2(-1.0,  0.0);
  offsets[4] = vec2( 0.0,  0.0);
  offsets[5] = vec2( 1.0,  0.0);
  offsets[6] = vec2(-1.0,  1.0);
  offsets[7] = vec2( 0.0,  1.0);
  offsets[8] = vec2( 1.0,  1.0);

  float kernel[9];
  kernel[0] = 1.0; kernel[1] = 2.0; kernel[2] = 1.0;
  kernel[3] = 2.0; kernel[4] = 4.0; kernel[5] = 2.0;
  kernel[6] = 1.0; kernel[7] = 2.0; kernel[8] = 1.0;
  float kernelWeight = 16.0;

  vec4 texColor = vec4(0.0);
  for (int i = 0; i < 9; i++) {
    texColor += texture2D(u_tex, vUv + offsets[i] * u_texelSize * blurStrength)
              * kernel[i];
  }
  texColor /= kernelWeight;
  float nValue = noise(vUv * noiseScale, 0.0);
  float distortedDistance = distance(vUv, vec2(0.5)) + nValue * noiseStrength;
  float edgeAlpha = smoothstep(0.6, 0.22, distortedDistance);

  texColor.a *= opacity * edgeAlpha;

  gl_FragColor = texColor;
}
